var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"camera-feed"},[_c('canvas',{ref:"canvas",staticClass:"camera-feed__canvas",attrs:{"id":"camera-feed-stage"}})])}
var staticRenderFns = []

export { render, staticRenderFns }